"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogPanel = void 0;
var vue_1 = require("vue");
var CardType_1 = require("../cards/CardType");
var LogMessageType_1 = require("../LogMessageType");
var LogMessageDataType_1 = require("../LogMessageDataType");
var Card_1 = require("./card/Card");
var i18n_1 = require("../directives/i18n");
var CardFinder_1 = require("./../CardFinder");
var TileType_1 = require("../TileType");
var utils_1 = require("../utils/utils");
var SoundManager_1 = require("./SoundManager");
var PreferencesManager_1 = require("./PreferencesManager");
var GlobalEvent_1 = require("./GlobalEvent");
var GlobalEventDealer_1 = require("../turmoil/globalEvents/GlobalEventDealer");
var PartyName_1 = require("../turmoil/parties/PartyName");
var Phase_1 = require("../Phase");
var logRequest;
exports.LogPanel = vue_1.default.component('log-panel', {
    props: {
        id: {
            type: String,
        },
        generation: {
            type: Number,
        },
        lastSoloGeneration: {
            type: Number,
        },
        players: {
            type: Array,
        },
        color: {
            type: String,
        },
    },
    data: function () {
        return {
            cards: [],
            globalEventNames: [],
            messages: [],
            selectedGeneration: this.generation,
        };
    },
    components: {
        Card: Card_1.Card,
        GlobalEvent: GlobalEvent_1.GlobalEvent,
    },
    methods: {
        scrollToEnd: function () {
            var scrollablePanel = document.getElementById('logpanel-scrollable');
            if (scrollablePanel !== null) {
                scrollablePanel.scrollTop = scrollablePanel.scrollHeight;
            }
        },
        cardToHtml: function (cardType, cardName) {
            var cardNameString = i18n_1.$t(cardName);
            var suffixFreeCardName = cardNameString.split(':')[0];
            var className;
            if (cardType === CardType_1.CardType.EVENT) {
                className = 'background-color-events';
            }
            else if (cardType === CardType_1.CardType.ACTIVE) {
                className = 'background-color-active';
            }
            else if (cardType === CardType_1.CardType.AUTOMATED) {
                className = 'background-color-automated';
            }
            else if (cardType === CardType_1.CardType.PRELUDE) {
                className = 'background-color-prelude';
            }
            else if (cardType === CardType_1.CardType.STANDARD_PROJECT || cardType === CardType_1.CardType.STANDARD_ACTION) {
                className = 'background-color-standard-project';
            }
            if (className === undefined) {
                return suffixFreeCardName;
            }
            return '<span class="log-card ' + className + '">' + suffixFreeCardName + '</span>';
        },
        messageDataToHTML: function (data) {
            var translatableMessageDataTypes = [
                LogMessageDataType_1.LogMessageDataType.STRING,
                LogMessageDataType_1.LogMessageDataType.STANDARD_PROJECT,
                LogMessageDataType_1.LogMessageDataType.MILESTONE,
                LogMessageDataType_1.LogMessageDataType.AWARD,
                LogMessageDataType_1.LogMessageDataType.COLONY,
                LogMessageDataType_1.LogMessageDataType.PARTY,
                LogMessageDataType_1.LogMessageDataType.TILE_TYPE,
                LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT,
            ];
            if (data.type === undefined || data.value === undefined) {
                return '';
            }
            switch (data.type) {
                case LogMessageDataType_1.LogMessageDataType.PLAYER:
                    for (var _i = 0, _a = this.players; _i < _a.length; _i++) {
                        var player = _a[_i];
                        if (data.value === player.color || data.value === player.id) {
                            return '<span class="log-player player_bg_color_' + player.color + '">' + player.name + '</span>';
                        }
                    }
                    break;
                case LogMessageDataType_1.LogMessageDataType.CARD:
                    var cardName = data.value;
                    for (var _b = 0, _c = this.players; _b < _c.length; _b++) {
                        var player = _c[_b];
                        if (player.corporationCard !== undefined && cardName === player.corporationCard.name) {
                            return '<span class="log-card background-color-global-event">' + i18n_1.$t(cardName) + '</span>';
                        }
                        else {
                            var robotCards = player.playedCards.concat(player.selfReplicatingRobotsCards);
                            for (var _d = 0, robotCards_1 = robotCards; _d < robotCards_1.length; _d++) {
                                var robotCard = robotCards_1[_d];
                                if (cardName === robotCard.name && robotCard.cardType !== undefined) {
                                    return this.cardToHtml(robotCard.cardType, cardName);
                                }
                            }
                        }
                    }
                    var card = new CardFinder_1.CardFinder().getCardByName(cardName, function (manifest) { return [
                        manifest.projectCards,
                        manifest.preludeCards,
                        manifest.standardProjects,
                        manifest.standardActions,
                        manifest.corporationCards,
                    ]; });
                    if (card && card.cardType) {
                        return this.cardToHtml(card.cardType, data.value);
                    }
                    break;
                case LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT:
                    var globalEventName = data.value;
                    return '<span class="log-card background-color-global-event">' + i18n_1.$t(globalEventName) + '</span>';
                case LogMessageDataType_1.LogMessageDataType.TILE_TYPE:
                    var tileType = +data.value;
                    return i18n_1.$t(TileType_1.TileType.toString(tileType));
                default:
                    if (translatableMessageDataTypes.includes(data.type)) {
                        return i18n_1.$t(data.value);
                    }
            }
            return data.value;
        },
        safeMessage: function (message) {
            try {
                if (message === undefined) {
                    return 'undefined';
                }
                if (message.data === undefined) {
                    return "BUG: Unparseable message: " + message.message;
                }
                var data = message.data.map(function (datum) {
                    return (datum === undefined) ?
                        'undefined' :
                        ('(' + datum.type + ') ' + datum.value);
                });
                return "BUG: Unparseable message: " + message.message + ", (" + data.join(', ') + ")";
            }
            catch (err) {
                return "BUG: Unparseable message: " + message.message + " " + err.toString();
            }
        },
        messageToHTML: function (message) {
            var _this = this;
            try {
                var logEntryBullet = '';
                if (message.type !== LogMessageType_1.LogMessageType.NEW_GENERATION) {
                    var when = new Date(message.timestamp).toLocaleString();
                    var icon = message.playerId === undefined ? '&#x1f551;' : '( &#x1f4ac;';
                    var iconClass = message.playerId === undefined ? '' : 'log-icon-private-message';
                    logEntryBullet = "<span title=\"" + when + "\" class=\"" + iconClass + "\">" + icon + "</span>";
                }
                if (message.type !== undefined && message.message !== undefined) {
                    message.message = i18n_1.$t(message.message);
                    var parsedMessage = message.message.replace(/\$\{(\d{1,2})\}/gi, function (_match, idx) {
                        if (message.playerId !== undefined && Number(idx) === 0 && message.data[0].type === LogMessageDataType_1.LogMessageDataType.PLAYER && _this.isGameEnded() === false) {
                            return 'You';
                        }
                        else {
                            return _this.messageDataToHTML(message.data[idx]);
                        }
                    });
                    return logEntryBullet + parsedMessage + ((message.playerId === undefined) ? '' : ')');
                }
            }
            catch (err) {
                return this.safeMessage(message);
            }
            return '';
        },
        messageToPlainText: function (message) {
            var _this = this;
            try {
                if (message.type !== undefined && message.message !== undefined) {
                    var parsedMessage = message.message.replace(/\$\{(\d{1,2})\}/gi, function (_match, idx) {
                        return _this.messageDataToHTML(message.data[idx]).replace(/<(.|\n)*?>/g, '');
                    });
                    if (message.playerId !== undefined) {
                        return '(' + parsedMessage + ')';
                    }
                    return parsedMessage;
                }
            }
            catch (err) {
                return this.safeMessage(message);
            }
            return '';
        },
        messageClicked: function (message) {
            var _this = this;
            var datas = message.data;
            datas.forEach(function (data) {
                if (data.value === undefined) {
                    return;
                }
                if (data.type === LogMessageDataType_1.LogMessageDataType.CARD) {
                    var cardName = data.value;
                    var index = _this.cards.indexOf(cardName);
                    if (index === -1) {
                        _this.cards.push(cardName);
                    }
                    else {
                        _this.cards.splice(index, 1);
                    }
                }
                if (data.type === LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT) {
                    var globalEventName = data.value;
                    var index = _this.globalEventNames.indexOf(globalEventName);
                    if (index === -1) {
                        _this.globalEventNames.push(globalEventName);
                    }
                    else {
                        _this.globalEventNames.splice(index, 1);
                    }
                }
            });
        },
        hideMe: function () {
            this.cards = [];
            this.globalEventNames = [];
        },
        getCrossHtml: function () {
            return '<i class=\'icon icon-cross\' />';
        },
        isGameEnded: function () {
            return this.players[0].game.phase === Phase_1.Phase.END;
        },
        selectGeneration: function (gen) {
            if (gen !== this.selectedGeneration || this.players[0].game.phase === Phase_1.Phase.END) {
                this.getLogsForGeneration(gen);
            }
            this.selectedGeneration = gen;
        },
        downloadLog: function () {
            var _this = this;
            var _a;
            var messages = this.messages;
            if (logRequest !== undefined) {
                logRequest.abort();
                logRequest = undefined;
            }
            var xhr = new XMLHttpRequest();
            logRequest = xhr;
            xhr.open('GET', "/api/game/logs?id=" + ((_a = this.players[0].game.spectatorId) !== null && _a !== void 0 ? _a : this.id) + "&generation=" + 0);
            xhr.onerror = function () {
                console.error('error updating messages, unable to reach server');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    messages.splice(0, messages.length);
                    messages.push.apply(messages, xhr.response);
                    var allMessages = xhr.response;
                    var plainifiedLog_1 = '';
                    allMessages.forEach(function (message) {
                        plainifiedLog_1 += _this.messageToPlainText(message) + '\n';
                    });
                    JSON.stringify(messages);
                    var dateFormat = require('dateformat');
                    var now = new Date();
                    var date = dateFormat(now, 'isoDateTime');
                    var blob = new Blob([plainifiedLog_1], { type: 'text/plain' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'game-log' + date;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                else {
                    console.error("error updating messages, response code " + xhr.status);
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        getLogsForGeneration: function (generation) {
            var _this = this;
            var messages = this.messages;
            if (logRequest !== undefined) {
                logRequest.abort();
                logRequest = undefined;
            }
            var xhr = new XMLHttpRequest();
            logRequest = xhr;
            xhr.open('GET', "/api/game/logs?id=" + this.id + "&generation=" + generation);
            xhr.onerror = function () {
                console.error('error updating messages, unable to reach server');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    messages.splice(0, messages.length);
                    messages.push.apply(messages, xhr.response);
                    if (PreferencesManager_1.PreferencesManager.loadBoolean('enable_sounds') && window.location.search.includes('experimental=1')) {
                        SoundManager_1.SoundManager.newLog();
                    }
                    if (generation === _this.generation) {
                        _this.$nextTick(_this.scrollToEnd);
                    }
                }
                else {
                    console.error("error updating messages, response code " + xhr.status);
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        getClassesGenIndicator: function (gen) {
            var classes = ['log-gen-indicator'];
            if (gen === this.selectedGeneration) {
                classes.push('log-gen-indicator--selected');
            }
            return classes.join(' ');
        },
        getGenerationsRange: function () {
            var generations = [];
            for (var i = 1; i <= this.generation; i++) {
                generations.push(i);
            }
            return generations;
        },
        getTitleClasses: function () {
            var classes = ['log-title'];
            classes.push(utils_1.playerColorClass(this.color.toLowerCase(), 'shadow'));
            return classes.join(' ');
        },
        lastGenerationClass: function () {
            return this.lastSoloGeneration === this.generation ? 'last-generation blink-animation' : '';
        },
        getResourcesOnCard: function (cardName) {
            var _a;
            for (var _i = 0, _b = this.players; _i < _b.length; _i++) {
                var player = _b[_i];
                if (((_a = player.corporationCard) === null || _a === void 0 ? void 0 : _a.name) === cardName)
                    return player.corporationCard.resources;
                var foundCard = player.playedCards.find(function (card) { return card.name === cardName; });
                if (foundCard !== undefined)
                    return foundCard.resources;
            }
            return undefined;
        },
        getGlobalEvent: function (globalEventName) {
            var globalEvent = GlobalEventDealer_1.getGlobalEventByName(globalEventName);
            if (globalEvent) {
                return {
                    name: globalEvent.name,
                    description: globalEvent.description,
                    revealed: globalEvent.revealedDelegate,
                    current: globalEvent.currentDelegate,
                };
            }
            return {
                name: globalEventName,
                description: 'global event not found',
                revealed: PartyName_1.PartyName.GREENS,
                current: PartyName_1.PartyName.GREENS,
            };
        },
    },
    mounted: function () {
        this.getLogsForGeneration(this.generation);
    },
    template: "\n      <div class=\"log-container\">\n        <div class=\"log-generations\">\n          <h2 :class=\"getTitleClasses()\">\n              <span v-i18n>Game log</span>\n          </h2>\n          <div class=\"log-gen-title\">Gen: </div>\n          <div class=\"log-gen-numbers\">\n            <div v-for=\"n in getGenerationsRange()\" :class=\"getClassesGenIndicator(n)\" v-on:click.prevent=\"selectGeneration(n)\">\n              {{ n }}\n            </div>\n          </div>\n          <span class=\"label-additional\" v-if=\"players.length === 1\"><span :class=\"lastGenerationClass\">of {{this.lastSoloGeneration}}</span></span>\n\n          <span v-if=\"isGameEnded()\">\n            <Button title=\"\uD83D\uDCBE-Save Log\" size=\"tiny\" class=\"save-image-button\" :onClick=\"_=>downloadLog()\"/>\n          </span>\n        </div>\n        <div class=\"panel log-panel\">\n          <div id=\"logpanel-scrollable\" class=\"panel-body\">\n            <ul v-if=\"messages\">\n              <li v-for=\"message in messages\" v-on:click.prevent=\"messageClicked(message)\" v-html=\"messageToHTML(message)\"></li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"card-panel\" v-if=\"cards.length > 0 || globalEventNames.length > 0\">\n          <Button size=\"big\" type=\"close\" :disableOnServerBusy=\"false\" :onClick=\"hideMe\" align=\"right\"/>\n          <div id=\"log_panel_card\" class=\"cardbox\" v-for=\"(card, index) in cards\" :key=\"card\">\n            <Card :card=\"{name: card, resources: getResourcesOnCard(card)}\"/>\n          </div>\n          <div id=\"log_panel_card\" class=\"cardbox\" v-for=\"(globalEventName, index) in globalEventNames\" :key=\"globalEventName\">\n            <global-event :globalEvent=\"getGlobalEvent(globalEventName)\" type=\"prior\"></global-event>\n          </div>\n        </div>\n      </div>\n    ",
});
//# sourceMappingURL=LogPanel.js.map